import { ReactNode } from 'react'
import { createPortal } from 'react-dom'

import { Box, theme } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Cross } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

type BaseModalProps = {
  isOpen: boolean
  onClose: () => void
  isLocked?: boolean
  width?: string
  children: ReactNode
}

const BaseModal = ({ isOpen, onClose, isLocked = false, width, children }: BaseModalProps) => {
  if (!isOpen) return null

  const modalContent = (
    <Box
      position="fixed"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: theme.zIndex.modals,
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
      }}
      onClick={() => {
        if (!isLocked) onClose()
      }}
    >
      <Box
        background="white"
        borderRadius={{
          all: 'abs016',
        }}
        position="relative"
        boxShadow="s50"
        style={{
          maxWidth: width || 'auto',
          minWidth: theme.dimensions.s400,
          margin: theme.dimensions.s24,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Box
          position="absolute"
          style={{
            top: theme.dimensions.s24,
            right: theme.dimensions.s24,
            zIndex: theme.zIndex.modals,
          }}
        >
          <F0Button
            onClick={onClose}
            variant="outline"
            size="md"
            icon={Cross}
            hideLabel
            label={i18n.t('common.close')}
          />
        </Box>
        {children}
      </Box>
    </Box>
  )

  if (typeof document === 'undefined') return null

  return createPortal(modalContent, document.body)
}

export default BaseModal
